import { GeometryType } from '../../../enums/index.js';
import { validateContourSet } from './validateContourSet.js';
import { ContourSet } from '../../../cache/classes/ContourSet.js';
export function createContourSet(geometryId, contourSetData) {
    validateContourSet(contourSetData);
    const contourSet = new ContourSet({
        id: contourSetData.id,
        data: contourSetData.data,
        color: contourSetData.color,
        frameOfReferenceUID: contourSetData.frameOfReferenceUID,
        segmentIndex: contourSetData.segmentIndex ?? 1,
    });
    const geometry = {
        id: geometryId,
        type: GeometryType.CONTOUR,
        data: contourSet,
        sizeInBytes: contourSet.sizeInBytes,
    };
    return geometry;
}
